module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/franchising/hero-desktop.01db551041e7c300f44ae67b8947426a.jpg";